import { styled } from '$utils/theme'

interface Props {
  top?: string
  bottom?: string
  left?: string
  right?: string
}

export const Circle = styled.div<Props>`
  height: 10px;
  width: 10px;
  background-color: ${p => p.theme.colors.darkPink};
  border: 2px solid ${p => p.theme.colors.white}
  border-radius: 100%;
  position: absolute;
  top: ${p => (p.top ? p.top : 0)};
  bottom: ${p => (p.bottom ? p.bottom : 'auto')};
  left: ${p => (p.left ? p.left : '55%')};
  right: ${p => (p.right ? p.right : '50%')};
`



// WEBPACK FOOTER //
// ./src/views/components/Circle/Circle.ts